'use client';

import React, { useEffect } from 'react';
import { useTheme } from '../../abstracts/theme';
import { ThemeProvider } from 'styled-components';
import { isReactDevelopment } from '../hooks';
const isJSDOM = () => {
  var _navigator, _navigator$userAgent, _navigator$userAgent$;
  return (_navigator = navigator) === null || _navigator === void 0 ? void 0 : (_navigator$userAgent = _navigator.userAgent) === null || _navigator$userAgent === void 0 ? void 0 : (_navigator$userAgent$ = _navigator$userAgent.includes) === null || _navigator$userAgent$ === void 0 ? void 0 : _navigator$userAgent$.call(_navigator$userAgent, 'jsdom');
};

/**
 * Provides internal stuff we need for our components.
 * Injects Styled Components theme prop via context.
 */
export const InternalProvider = ({
  children
}) => {
  const theme = useTheme();
  useEffect(() => {
    const style = getComputedStyle(document.body);
    const globalStylesExists = !!style.getPropertyValue('--aui-global-styles-exists');
    if (!globalStylesExists && isReactDevelopment() && !isJSDOM()) {
      console.error('ERROR: Your AsurionUI components WILL BREAK in a future V4 minor version update. You must include GlobalStyles in your DOM. For more information, see https://ui.asurion.com/?path=/docs/documentation-getting-started--docs#global-styles');
    }
  }, []);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, children);
};